export default __webpack_public_path__ + "static/kokall-zomer-2-71e7b21b8bf3641331c0c65863d72a62.png";